import * as React from 'react';
import { memo } from "react";
import { HexColorInput, HexColorPicker } from "react-colorful";
import './colorPicker.css';
import { isFunction, isObject } from "../helpers/utils";
import ColorSwatch from "./colorSwatch.tsx";

type Props = Readonly<{
	color: string,
	onChange: Function,
	preset: Object
}>

function ColorPicker({color, onChange, preset}: Props) {

	function update(color: string) {
		if (isFunction(onChange)) {
			onChange(color);
		}
	}

	function renderSwatches() {
		let toReturn = [];

		if (preset && isObject(preset)) {
			for (let colorName in preset) {
				toReturn.push(
					<ColorSwatch
						className="mt-4"
						key={colorName}
						color={preset[colorName]}
						selected={color === preset[colorName]}
						onClick={() => update(preset[colorName])}
					/>
				);
			}
		}

		return toReturn;
	}

	return (<>
		<div className="flex justify-center mb-4">
			<span className="text-2xl text-grey-400">#</span>
			<HexColorInput
				color={color}
				onChange={update}
				className='inline-block !bg-white w-[205px] ml-1'
				type="text"
			/>
		</div>

		<div className="customColorPicker">
			<HexColorPicker color={color} onChange={update}/>
		</div>

		<div className="flex flex-wrap content-between justify-between">
			<ColorSwatch
				className="bg-no-color mt-4" onClick={() => update('')}
				selected={color === null || color === '' || color === undefined}
			/>
			{renderSwatches()}
		</div>
		{/*<Dump {...backgroundSettings}/>*/}
	</>);
}

export default memo(ColorPicker);
